module.exports = __webpack_public_path__ + "static/media/acougue.c033db2d.jpg";